module.exports = __webpack_public_path__ + "img/header-cert2-sent.02f6ba16.png";